import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import type { SendAllChip } from './sendAllModel';
import { sendAllMessages as s } from './sendAllMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Send to all sheet; each part uses its own slice of it */
import styles from './SendAll.module.scss';
/* eslint-enable css-modules/no-unused-class */

const TONE: Record<SendAllChip['kind'] | 'comingSoon', string | undefined> = {
  live: styles.chipOk,
  sending: styles.chipAmber,
  waiting: styles.chipNil,
  failed: styles.chipBad,
  readOnly: styles.chipNil,
  comingSoon: styles.chipNil,
};

interface SendAllChipBadgeProps {
  kind: SendAllChip['kind'] | 'comingSoon';
  at?: string | null;
  testId?: string;
}

/** The status pill of an item or a service (design c `.ck`): Live since, Sending, Waiting, Failed, Read-only. */
const SendAllChipBadgeComponent: React.FC<SendAllChipBadgeProps> = ({ kind, at = null, testId }) => {
  const intl = useIntl();
  let text: string;
  switch (kind) {
    case 'live':
      text =
        at === null
          ? intl.formatMessage(s.chipLiveNoTime)
          : intl.formatMessage(s.chipLive, {
              time: intl.formatDate(at, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }),
            });
      break;
    case 'sending':
      text = intl.formatMessage(s.chipSending);
      break;
    case 'waiting':
      text = intl.formatMessage(s.chipWaiting);
      break;
    case 'failed':
      text = intl.formatMessage(s.chipFailed);
      break;
    case 'readOnly':
      text = intl.formatMessage(s.chipReadOnly);
      break;
    case 'comingSoon':
      text = intl.formatMessage(s.chipComingSoon);
      break;
  }
  return (
    <span className={clsx(styles.chip, TONE[kind])} data-testid={testId}>
      {text}
    </span>
  );
};

export const SendAllChipBadge = TypedMemo(SendAllChipBadgeComponent);
